import { Keyword, ParsedSchemaProperty, PureCustomValueData } from "PFTypes";
import PropTypes from "prop-types";
import { CSSProperties, RefObject } from "react";

export type ComponentProps = {
  className?: string;
  property: ParsedSchemaProperty;
  onChange: (values: PureCustomValueData[] | Keyword[], property?: ParsedSchemaProperty) => any;
  value?: string;
  label?: string;
  title?: string;
  formattedTitle?: string;
  qaId?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  variant?: "default" | "table";
  portalRef?: RefObject<HTMLDivElement | null>;
  dropdownWidth?: number;
  tabIndex?: number;
  style?: CSSProperties;
  inputRef?: RefObject<any>;
};

export const ComponentPropTypes = {
  property: PropTypes.shape({
    type: PropTypes.string,
    kind: PropTypes.oneOf(["multiple", "single", "nested"]),
    required: PropTypes.array,
    name: PropTypes.string,
    enum: PropTypes.array
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  formattedTitle: PropTypes.string,
  qaId: PropTypes.string,
  style: PropTypes.object,
  required: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "table"]),
  portalRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  tabIndex: PropTypes.number
};
